import { buildSearchDoc } from '@core/search-core';
import type { SearchDoc } from '@core/search-core';
import type { CatalogManifestEntry } from '@/lib/types';

// ONE mapping from a manifest entry to the shared search core's scoring
// doc, so every web search surface (⌘K SearchModal, MapMode overlay,
// Browse ?q=, DestinationPicker, BookingEditor) indexes the same fields
// the same way. WeakMap-cached: manifest entries are long-lived objects
// from the per-trip manifest cache, so per-keystroke re-ranking reuses
// the same docs instead of re-normalizing thousands of strings.
//
// `detail` (weakest scoring rung) is standardized across surfaces:
// country / highlight / entityType / priceLabel.
const cache = new WeakMap<CatalogManifestEntry, SearchDoc>();

export function docOfManifestEntry(e: CatalogManifestEntry): SearchDoc {
  const hit = cache.get(e);
  if (hit) return hit;
  const doc = buildSearchDoc({
    name: e.name,
    id: e.id,
    aliases: e.aliases,
    region: e.region,
    subregion: e.subregion,
    cuisine: e.cuisine,
    tags: e.tags,
    type: e.type,
    detail: [e.country, e.highlight, e.entityType, e.priceLabel]
      .filter(Boolean)
      .join(' · '),
  });
  cache.set(e, doc);
  return doc;
}
